import { Component, OnInit } from '@angular/core';
import {TicketsService} from 'src/app/services/'
import {CreateTicketFormFields,SaveBatchTicket,SelectedBatchEquipment} from 'src/app/models/tickets/createTicketFormFields'


@Component({
  selector: 'bart-software-update',
  templateUrl: './software-update.component.html',
  styleUrls: ['./software-update.component.scss']

})



export class SoftwareUpdateComponent implements OnInit {


  public SoftwareSelectedData:softwareVersin[];
  public formFields:CreateTicketFormFields;
  public objSaveBatchTicket:SaveBatchTicket;

  public data: any[];
  public dataSource: any[];
  public totalRecords:number=0;
  cols: any[];
  colsNew: any[];
  users:any[];
  loading = false;
  public selectDataColumns:any[];
  public selectedData: any[];
  public SelectionForDelete: any;
  NextBtnShowHide:boolean=true;
  ModifyBtnShowHide:boolean=false;
  public buildCheckList_Data:any[]=[];

  public disabled:boolean=false;
  public errorClass:string="";
  public btnactive="Next";

  public errorHeader:string="";
  public errorContent:string="";
  public displayError:boolean=false;




  public btnModifyClicked()
  {
   //this.btnactive="Next";
   this.NextBtnShowHide=true;
      this.ModifyBtnShowHide=false;
   this.formFields.isShowBatchLabour=false;
   this.disabled=false;
  }


  public btnBackClicked()
  {
   this.formFields.showCurrentTemplate=false
    }
  btnNextTemplate()
  {
   var saveOk = this.AssignData(true);

   if(saveOk)
   { 
    if(this.SoftwareSelectedData.length>0)
    {
      this.NextBtnShowHide=false;
      this.ModifyBtnShowHide=true;
      this.formFields.isShowBatchLabour=true;
      this.disabled=true;
    }
    else
    {
      this.btnBackClicked();
    }
   }
   else
   {
     this.NextBtnShowHide=true;
     this.ModifyBtnShowHide=false;
     this.formFields.isShowBatchLabour=false;
      this.disabled=false;
   }


   
  }
 
 

  constructor(
    private _ticketService:TicketsService,

  ) {
   this.formFields=new CreateTicketFormFields();

   }

  ngOnInit() {


    this._ticketService.getTicketGlobalData().subscribe((Result: any) => 
    {
      this.formFields = Result;
      this.SoftwareSelectedData=this.formFields.selectedBatchEquipmentList;
    },
    (error) => 
    {
      console.log(error);
    }
    );
    for(var curEquipId of this.SoftwareSelectedData)
    {
    this.generateSoftwareVersionTDs(curEquipId)
    }



  }


  public checkvalidation(obj:softwareVersin)
 {
    
      var success=true;
    let ret:softwareupdateErrors = 
    {
      softwareupdateerrorOk:false,
      mainErrorMessage:"",
      errorMsg:[]
    };
      this.objSaveBatchTicket.equipmentId=obj.EquipmentID;
      //if(obj.generalSoftware!=undefined && obj.generalSoftware<="0")
      if(obj.GeneralSoftwareVersion != undefined && obj.GeneralSoftwareVersion != ""  && obj.GeneralSoftwareVersion.length>10)
      {
        success=false;
        ret.errorMsg.push('Equipment Software Versions should be within 10 characters.');
        ret.softwareupdateerrorOk = false;
      }
      else 
      {
        ret.softwareupdateerrorOk = true;
      }
      
      //if(obj.Acturaor!=undefined && obj.Acturaor<="0")
      if(obj.ActuatorVersion != undefined && obj.ActuatorVersion != ""  && obj.ActuatorVersion.length>10)
      {
        ret.errorMsg.push('Equipment Module 1 should be within 10 characters.');
         ret.softwareupdateerrorOk = false;
        success=false;
      }
      else 
      {
        ret.softwareupdateerrorOk = true;
      }
     
      //if(obj.functional!=undefined && obj.functional<="0")
      if(obj.FunctionalVersion != undefined && obj.FunctionalVersion != ""  && obj.FunctionalVersion.length>10)
      {
         ret.errorMsg.push('Equipment Module 2 should be within 10 characters.');
         ret.softwareupdateerrorOk = false;
        success=false;
      }
      else 
      {
        ret.softwareupdateerrorOk = true;
      }
      if(ret.errorMsg.length>0)
      {
        obj.errorClass="batchError";
        ret.mainErrorMessage='Errors found for equipment with serial number ' + obj.EquipmentSerialNumber + '<br/>';
      }
      else
      {
        obj.errorClass="";
      }
    
    return ret
 }


  public RemoveRow(equipmentId:any)
  {
   
    this.SoftwareSelectedData=this.SoftwareSelectedData.filter(x=>x.EquipmentID!=equipmentId);
    this.formFields.selectedBatchEquipmentList=this.SoftwareSelectedData.filter(x=>x.EquipmentID!=equipmentId);
    if(this.SoftwareSelectedData.length==0)
    {
      this.formFields.isShowBatchLabour = false;
      this.formFields.selectedBatchEquipmentData=[];

    } 
    if(this.formFields.selectedBatchEquipmentData["EquipmentID"]== equipmentId)
    {
     this.formFields.selectedBatchEquipmentData=[];
    } 
   
    
  }




  public generateSoftwareVersionTDs(curEquipId:any) {
 
    let count:number=0;
    var rowHTMLSW = "";
   let element = this.SoftwareSelectedData.find(tt=>tt.EquipmentID == curEquipId.EquipmentID)
   
    let commaSplitSWOptions:any = curEquipId.SoftwareVersion!=null? curEquipId.SoftwareVersion.split(","):"";
   
    if (commaSplitSWOptions.indexOf("1_1") > -1) {
      element.block1="1";
        rowHTMLSW += "<td- align='left' w=idth='13%'><input type=text id='equipmentGeneralSoftware" + curEquipId + "'></td>";
       
    }
    else if (commaSplitSWOptions.indexOf("1_1") == -1) {
        rowHTMLSW += "<td align='left' width='15%' id='f1'>N/A</td>";
    }

    if (commaSplitSWOptions.indexOf("2_1") > -1) {
      element.block2="2"
        rowHTMLSW += "<td align='left' width='13%'><input type=text id='equipmentActuator" + curEquipId + "'></td>";
       
    }
    else if (commaSplitSWOptions.indexOf("2_1") == -1) {
     
        rowHTMLSW += "<td align='left' width='15%' id='f2'>N/A</td>";
    }

    if (commaSplitSWOptions.indexOf("3_1") > -1) {
      element.block3="3"
    
        rowHTMLSW += "<td align='left' width='13%'><input type=text id='equipmentFunctional" + curEquipId + "'></td>";
    }
    else if (commaSplitSWOptions.indexOf("3_1") == -1) {
        rowHTMLSW += "<td align='left' width='15%' id='f3'>N/A</td>";
        
    }

 
    console.log(element)
    return rowHTMLSW;
}

public hideErrorDialog()
 {
  this.displayError=false;
 }

  public AssignData(showAlert:any)
    {

      this.objSaveBatchTicket=new SaveBatchTicket();
      let success:boolean=true;
      let errors:softwareupdateErrors[]=[];
      this.formFields.batchTicketObj=[]
       var result=true;
       for(let obj of this.SoftwareSelectedData)
       {
          let equipmentId=obj.EquipmentID;
          let serialNumber =obj.EquipmentSerialNumber;
          let ret =this.checkvalidation(obj);
          if(ret.errorMsg.length>0)
          {
            errors.push(ret);
          }
       }
         

       
       if(errors.length==0)
       {
        for(let obj of this.SoftwareSelectedData)
        {
          this.objSaveBatchTicket=new SaveBatchTicket();
            this.objSaveBatchTicket.equipmentId=obj.EquipmentID
        
           this.objSaveBatchTicket.GeneralSoftware=obj.GeneralSoftwareVersion
           this.objSaveBatchTicket.Actuator=obj.ActuatorVersion;
           this.objSaveBatchTicket.Functional=obj.FunctionalVersion;
            this.formFields.batchTicketObj.push(this.objSaveBatchTicket);
        }
      }
      else
      {
        success=false;
        this.formFields.batchTicketObj=null;
        
          
            this.errorClass="batchError"
          
        
        var errorMsg = '';
        var i = 0;
         for(let x of errors)
         {
          errorMsg += "<div class='errorHeader'>"+x.mainErrorMessage +"</div>";
          for (i=0;i<x.errorMsg.length;i++) 
          {
            errorMsg += x.errorMsg[i] + '<br/>';
          }
         }
         if(showAlert)
         {
           
           this.errorHeader="Validation Error";
           this.errorContent=errorMsg;
           this.displayError=true;
         }
      }
      return success;
        
    }

  }
    



export class softwareupdateErrors 
{
  softwareupdateerrorOk:boolean;
  mainErrorMessage:string;
  errorMsg:string[]=[];
}

export  class  softwareVersin extends SelectedBatchEquipment
  {
     
     serial?:number
    generalSoftware?:string
     Acturaor?:string;
     functional?:string;
    
     errorClass:string="";
     block1:string="";
     block2:string="";
     block3:string=""

    
  
  }